export default __webpack_public_path__ + "static/media/Belt of Vicious Frenzy.f9b8f805.jpg";